<cm-project-header [data]="headerData$ | async"></cm-project-header>

<p-tabs [value]="activeRoute$ | async"
        scrollable>
  <p-tablist class="sc-flex-tab-menu">
    @for (tab of navigationTabs; track tab.routerLink) {
      @if (tab.visible !== false) {
        <p-tab [value]="tab.routerLink"
               [routerLink]="tab.routerLink">
          {{ tab.label }}
        </p-tab>
      }
    }
  </p-tablist>
</p-tabs>

<router-outlet></router-outlet>